export default function SizeLabel({
  x,          // % от ширины контейнера
  y,          // % от высоты контейнера
  text,       // «123 мм»
  angle  = 0, // угол подписи, deg
  fontPx = 9, // базовый размер шрифта
  lineLen = 16,
  lineGap = 4,
}) {
  /* базовый стиль подписи */
  const labelStyle = {
    position        : 'absolute',
    left            : `${x}%`,
    top             : `${y}%`,
    transform       : `translate(-50%, -50%) rotate(${angle}deg)`,
    transformOrigin : 'center',
    padding         : '2px 6px',

    fontSize   : `${fontPx}px`,
    fontWeight : 600,
    lineHeight : 1,

    color        : '#1d1d1f',
    background   : 'rgba(255, 255, 255, 0.85)',
    borderRadius : 4,
    boxShadow    : '0 1px 4px rgba(0,0,0,.15)',
    textShadow   : '0 0 1px rgba(0,0,0,.12)',

    whiteSpace    : 'nowrap',
    pointerEvents : 'none',
    userSelect    : 'none',
    zIndex        : 4,
  };

  const isVertical = Math.abs(angle % 180) === 90;

  /* пунктирная направляющая через repeating-gradient */
  const lineStyle = isVertical
    ? {
        position   : 'absolute',
        left       : `${x}%`,
        top        : `${y}%`,
        width      : 0,
        height     : `${lineLen}px`,
        transform  : `translate(-50%, calc(-50% - ${lineGap}px))`,
        backgroundImage :
          'repeating-linear-gradient(' +
          'to bottom,' +
          '#ff3b30 0 4px,' +     // штрих 4 px
          'transparent 4px 8px'  // промежуток 4 px
          + ')',
        backgroundRepeat : 'repeat-y',
        backgroundSize   : '1px 8px',
        zIndex           : 3,
        pointerEvents    : 'none',
      }
    : {
        position   : 'absolute',
        left       : `${x}%`,
        top        : `${y}%`,
        width      : `${lineLen}px`,
        height     : 0,
        transform  : `translate(calc(-50% - ${lineGap}px), -50%)`,
        backgroundImage :
          'repeating-linear-gradient(' +
          'to right,' +
          '#ff3b30 0 4px,' +
          'transparent 4px 8px' +
          ')',
        backgroundRepeat : 'repeat-x',
        backgroundSize   : '8px 1px',
        zIndex           : 3,
        pointerEvents    : 'none',
      };

  return (
    <>
      <div style={lineStyle} />
      <div style={labelStyle}>{text}</div>
    </>
  );
}
